// 特色服务
import request from '@/utils/request.js';


// 经营许可证列表
export function handlerGetCertList(data) {
    return request({
        apiModule: 'user',
        url: '/cert/list',
        method: 'get',
        params: data,
    });
}

// 字典
export function handlerPublicGetDictList(data) {
    return request({
        apiModule: 'adminapi',
        url: '/dict/list',
        method: 'get',
        params: data,
    });
}

// 添加证书资质
export function handlerAddCertDataList(data) {
    return request({
        apiModule: 'user',
        url: '/cert/add',
        method: 'post',
        data: data,
    });
}

// 修改
export function handlerEditCertDataList(data) {
    return request({
        apiModule: 'user',
        url: '/cert/update',
        method: 'post',
        data: data,
    });
}

// 删除
export function handlerDelCertData(data) {
    return request({
        apiModule: 'user',
        url: '/cert/del',
        method: 'post',
        data: data,
    });
}

// 许可证详情
export function handlerGetCertDetail(data) {
    return request({
        apiModule: 'user',
        url: '/cert/detail',
        method: 'get',
        params: data,
    });
}

// 检测类目
export function handlerCheckCategory(data) {
    return request({
        apiModule: 'goods',
        url: '/category/check',
        method: 'get',
        params: data,
    });
}